import { PageHeader } from "antd";
import K from "utilities/constants";
import { ReportContainer } from "./reportContainer/reportContainer";
import LayoutCss from "../../layout/layout.module.scss";

export const RecruiterPerformanceReporting = () => {
  return (
    <>
      <PageHeader
        ghost={false}
        title="Recruiter Performance"
        className={LayoutCss.appPageHeader}
      />
      <ReportContainer type={K.Clients.Reports.Type.RecruiterProductivity} />
    </>
  );
};
